import React from 'react';
import { TaskState } from 'gql/graphql';
import { LoanPhases } from 'scenes/Private/Dashboard/LoanPhases.constanst';

// SVG imports
import checkSvg from 'assets/images/check-circle.svg';
import checkGreenSvg from 'assets/images/check-green-ligth.svg';
import alertSvg from 'assets/images/alert-circle.svg';
import loaderSvg from 'assets/images/loader-blue.svg';
import clockSvg from 'assets/images/clock-purple-light.svg';

interface TaskStateIconProps {
  state: string;
}

export const TaskStateIcon: React.FC<TaskStateIconProps> = ({ state }) => {
  if (state === TaskState.Approved) {
    return <img src={checkGreenSvg} alt="check" className="check" />;
  }
  if (state === TaskState.RequestError || state === 'BLOCKED') {
    return <img src={alertSvg} alt="check" className="check" />;
  }
  if (state === TaskState.Review) {
    return <img src={clockSvg} alt="check" className="check" />;
  }
  if (state === TaskState.Draft || state === TaskState.Incomplete || state === TaskState.ComingSoon) {
    return <div className='circle' />;
  }
  return null;
};

interface TagStatusProps {
  state: string;
  stateName: string;
}

export const TagStatus: React.FC<TagStatusProps> = ({ state, stateName }) => {
  return (
    <div className={`tag-state`}>
      {(state === 'error' || state === 'blocked') && (
        <img src={alertSvg} alt="error" />
      )}
      {state === 'complete' && <img src={checkSvg} alt="check" />}
      {state === 'progress' && <img src={loaderSvg} alt="loader" />}
      <b>{stateName}</b>
      {(state === 'error' || state === 'blocked') && (
        <>
          <b>|</b>
          <span>Borrower action required</span>
        </>
      )}
    </div>
  );
};

interface TabBarProgressProps {
  tab: LoanPhases;
}

export const TabBarProgress: React.FC<TabBarProgressProps> = ({ tab }) => {
  return (
    <div className='popover-label'>
      <p className="body-x-small body-small-w4">{tab.name}</p>
      <div className={`bar-status  phase-selected-${tab.key}`} />
    </div>
  );
};